import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import WorkOrdersDashboardLayer from "../components/dashboards/WorkOrdersDashboardLayer";

const WorkOrdersDashboardPage = () => {
  return (
    <>
      <MasterLayout pageTitle="Work Orders Dashboard">
        <WorkOrdersDashboardLayer />
      </MasterLayout>
    </>
  );
};

export default WorkOrdersDashboardPage;
